let deferredPrompt: any = null;
let initialized = false;

/** Сайт открыт во вложенном фрейме (Telegram Web, виджет и т.д.). */
export function isEmbeddedInIframe(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isLikelyIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const ipadOs =
    navigator.platform === "MacIntel" && Number(navigator.maxTouchPoints) > 1;
  return ua || ipadOs;
}

/** Десктопный браузер на Windows (не Android-эмуляция в UA). */
export function isLikelyWindowsDesktop(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (!/Windows NT/i.test(ua)) return false;
  if (/Android/i.test(ua)) return false;
  if (/iPhone|iPad|iPod/i.test(ua)) return false;
  return true;
}

export function initPwaInstallPrompt() {
  if (initialized) return;
  initialized = true;

  if (typeof window === "undefined") return;

  const installedKey = "pwa_installed";

  window.addEventListener("beforeinstallprompt", (e: any) => {
    // Для отладки: на некоторых платформах событие может не срабатывать.
    // Если оно прилетает — кнопка должна стать активной.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.log("[PWA] beforeinstallprompt fired");
    }
    // Важно: preventDefault нужен, чтобы браузер не показывал свое окно,
    // и мы смогли отобразить кнопку на нужной странице.
    e.preventDefault();
    deferredPrompt = e;
    try {
      localStorage.setItem(installedKey, "0");
    } catch {
      // ignore
    }
  });

  window.addEventListener("appinstalled", () => {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.log("[PWA] appinstalled fired");
    }
    deferredPrompt = null;
    try {
      localStorage.setItem(installedKey, "1");
    } catch {
      // ignore
    }
  });
}

export function getDeferredPrompt() {
  return deferredPrompt;
}

export function isPwaInstalled() {
  try {
    return localStorage.getItem("pwa_installed") === "1";
  } catch {
    return false;
  }
}

export function isStandaloneMode(): boolean {
  // iOS/Safari и часть браузеров
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const iosStandalone = (window as any).navigator?.standalone;
  if (iosStandalone) return true;

  // Chromium
  const displayMode = window.matchMedia?.("(display-mode: standalone)")?.matches;
  return !!displayMode;
}

